export function omnitureClickTrack() {
    if (window.espnTrackingConfig.trackingDisabled) {
        return Promise.resolve();
    } else {
        const _this = this;
        return new Promise((resolve) => {
            try {
                /**
                 * EX:
                 *
                 * espn
                 *  pev2=buy:espn+:monthly&
                 * linkid=buy:espn+:monthly:7ft&
                 * products=D2C;8400199910209919951899000&
                 * buylocation=espn+:paywall:buy
                 *
                 * mlb
                 *  pev2=buy:mlbtv:monthly&
                 * linkid=buy:mlbtv:monthly:7ft&
                 * products=D2C;D2C;8401199910209919951801000,:8400199910209919951899000&
                 * buylocation=mlbtv:paywall:buy
                 *
                 * nhl
                 *  pev2=buy:nhltv:monthly&
                 * linkid=buy:nhltv:monthly:7ft&
                 * products=D2C;8402199910209919951801000&
                 * buylocation=nhltv:paywall:buy
                 *
                 */

                const defaultPropsToExclude = [
                    'upsellshown',
                    'internalmkt',
                    'externalmkt',
                    'purchaseid',
                    'paywallvisitcount',
                    'paywallshown',
                    'contenttype',
                    'section',
                    'adblocker',
                    'premium',
                    'registrationtype',
                    'lang',
                    'birthage',
                    'lastvisit',
                    'visitortype',
                    'sport',
                    'league',
                    'gender',
                    'programdata'
                ];
                window.btmTracking.trackAsync.call(_this, defaultPropsToExclude)
                    .then(resolve, resolve);
            } catch (err) {
                console.error('error trying to send click track', err);
                resolve();
            }
        });
    }
}

export const addVisitorTrackingIDs = (button) => {
    const { loginSuccessUrl } = $(button).data();
    const href = button.href;
    const marketingCloudID = window.espnTrackingConfig
        && window.espnTrackingConfig.adobeAnalytics
        && window.espnTrackingConfig.adobeAnalytics.marketingCloudId;
    const visitor = window.Visitor && window.Visitor.getInstance(marketingCloudID);

    if (visitor) {
        if (loginSuccessUrl) {
            button.dataset.loginSuccessUrl = visitor.appendVisitorIDsTo(loginSuccessUrl);
        } else {
            button.href = visitor.appendVisitorIDsTo(href);
        }
    }

    return button;
};

